import { Permissions } from '../../../../models/enums/permissions';
import * as React from 'react';
import { ClearButton } from '../../../../components/button/ClearButton';
import { HasPermission } from '../../../../containers/authorization-helpers/HasPermission';
import { toLongDateTime } from '../../../../utils/date-utils';
import { MessageStatusMetadata } from '../../models/enums/message-status';
import { MessageTypeMetadata } from '../../models/enums/message-type';
import { TemplateTypeMetadata } from '../../models/enums/template-type';
import { MessageRead } from '../../models/messages/message-read';

// #region Component Props

interface IProps {
    message         : MessageRead;
    downloadAction  : any;
    resendAction    : any;
}

// #endregion

export const ActivityFeedMessageRow = (props: IProps) => (

    <tr>
        <td>{ toLongDateTime(props.message.createdOn)  }</td>
        <td>{ MessageStatusMetadata[props.message.status] ? MessageStatusMetadata[props.message.status].display : '' }</td>
        <td>{ MessageTypeMetadata[props.message.type] ? MessageTypeMetadata[props.message.type].display : '' }</td>
        <td>{ TemplateTypeMetadata[props.message.template] ? TemplateTypeMetadata[props.message.template].display : '' }</td>
        <td>{ props.message.shipmentId }</td>   
        <td>{ props.message.destination }</td>
        <td>{ props.message.dealerId }</td>               
        <td>
            <ClearButton
                id={"commsmessage-" + props.message.id}
                text="Download"
                classes="action commmessage-action"
                onBtnClick={ () => props.downloadAction(props.message.id!) }
                icon="la-file-pdf-o" />
            
            <HasPermission requiredPermissions={[
                Permissions.CommunicationsActivityFeedResend]}> 
                <ClearButton
                    id={"commsresend-" + props.message.id}
                    text="Resend"
                    classes="action commmessage-action"
                    onBtnClick={ () => props.resendAction(props.message.id!) }
                    icon="la-send" />
            </HasPermission>
        </td>
    </tr>

);
